import {
  Injectable,
  Inject
} from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable()
export class ChartService {

  componentSubject = new Subject<any>();

  constructor() { }

  setComponentObject(component) {
    this.componentSubject.next(component);
  }

  getComponentObject(): Observable<any> {
    return this.componentSubject.asObservable();
  }

}
